// Auth hook implementation
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
;

/**
 * Enhanced useAuth hook that uses real Supabase users
 * For development/testing, it automatically logs in as paras@metasage.ai (plant_manager)
 */
export function useAuth() {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    // Check for an existing session or use a real user from the database
    const checkSessionOrUseRealUser = async () => {
      try {
        // First try to get an existing session
        const { data: sessionData } = await supabase.auth.getSession();
        
        if (sessionData?.session?.user) {
          
          // Get the user profile data to include role and department
          const { data: profileData } = await supabase
            .from('profiles')
            .select('*')
            .eq('id', sessionData.session.user.id)
            .single();
          
          if (profileData) {
            // Combine auth user with profile data
            setUser({
              ...sessionData.session.user,
              role: profileData.role,
              department: profileData.department,
              company_id: profileData.company_id, // Add company_id
              companyId: profileData.company_id, // Add companyId for backwards compatibility
              name: profileData.name || `${profileData.first_name || ''} ${profileData.last_name || ''}`.trim()
            });
            
          } else {
            setUser(sessionData.session.user);
            
          }
        } else {
          // No session, use a real user from the database for development
          
          
          // Get a real user from the profiles table (paras@metasage.ai)
          const { data: profileData } = await supabase
            .from('profiles')
            .select('*')
            .eq('email', 'paras@metasage.ai')
            .single();
          
          if (profileData) {
            // Use the real user data
            setUser({
              id: profileData.id,
              email: profileData.email,
              role: profileData.role,
              department: profileData.department,
              company_id: profileData.company_id, // Add company_id
              companyId: profileData.company_id, // Add companyId for backwards compatibility
              name: profileData.name || `${profileData.first_name || ''} ${profileData.last_name || ''}`.trim()
            });
            
          } else {
            setUser(null);
          }
        }
      } catch {
        setUser(null);
      } finally {
        setIsLoading(false);
      }
    };
    
    checkSessionOrUseRealUser();
  }, []);
  
  return {
    user,
    signIn: () => Promise.resolve(),
    signOut: () => Promise.resolve(),
    isLoading,
    isAuthenticated: !!user,
  };
}
